export function arrayToObjectResponse(arrayResponse, key = 'key') {
  return arrayResponse.reduce((acc, item) => {
    return {
      ...acc,
      [item?.[key]]: item,
    };
  }, {});
}
